import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prevent",
  "use": "icon-prevent-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-prevent\"><defs><style>#icon-prevent .cls-1{fill:#fff;}</style></defs><path class=\"cls-1\" d=\"M12,.51A11.5,11.5,0,1,0,23.51,12,11.51,11.51,0,0,0,12,.51ZM2.93,12A9.06,9.06,0,0,1,17.51,4.8L4.8,17.51A9,9,0,0,1,2.93,12ZM12,21.09a9,9,0,0,1-5.5-1.87L19.22,6.51A9.06,9.06,0,0,1,12,21.09Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol